"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPencilSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M40.874 13.537l4.929-4.928 15.578 15.577-4.929 4.929zM37.74 16.68L8.62 45.81v15.57h15.57l29.13-29.12-15.58-15.58z"
  })),
  height: undefined,
  width: undefined
});
IconPencilSolid.displayName = 'IconPencilSolid';
var _default = IconPencilSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/pencil-solid.js
// module id = 576
// module chunks = 0